export default __webpack_public_path__ + "static/media/Gallery-3.506541b5.jpg";